<div class="w-full px-4">
    <div class="w-full flex flex-column gap-3">
      <div class="w-full flex align-items-center gap-2 justify-content-between">
        <h1 class="text-left font-bold text-4xl">Scheduled Mentor Calls</h1>
        <!-- <a class="w-auto px-3 py-2 border-round-lg inline-flex align-items-center gap-2 text-center recent_mettings">
          <i class="pi pi-history"></i>
          <p class="hidden sm:inline-block">Recent Meetings</p>
        </a> -->
      </div>
      <div class="w-full flex flex-column gap-2 py-4 px-3 bg-white border-round-2xl shadow-2">
        <h2 class="text-left text-xl font-medium px-2" style="color: #101011;">Search</h2>
        <form [formGroup]="filterForm" (ngSubmit)="search(1)" class="w-full flex flex-wrap">
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="text-left font-normal text-base" style="color: #424242;">From Date</b>
            <p-calendar formControlName="fromDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
              class="w-full" styleClass="cal_full" />
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="text-left font-normal text-base" style="color: #424242;">To Date</b>
            <p-calendar formControlName="toDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay"
              class="w-full" styleClass="cal_full" />
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="text-left font-normal text-base" style="color: #424242;">Mentor Name</b>
            <p-autoComplete placeholder="Name" formControlName= "mentorName" [suggestions]="mentorNames"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('mentorName')?.value}"
              class="w-full" (completeMethod)="filterMentorNames($event)" styleClass="fullWidth" optionValue="name"
              optionLabel="name">
            </p-autoComplete>
          </div>
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="text-left font-normal text-base" style="color: #424242;">Student Name</b>
            <p-autoComplete placeholder="Name" formControlName= "studentName" [suggestions]="studentNames"
              [ngClass]="{'ng-invalid ng-dirty': submitted && !filterForm.get('studentName')?.value}"
              class="w-full" (completeMethod)="filterStudentNames($event)" styleClass="fullWidth" optionValue="name"
              optionLabel="name">
            </p-autoComplete>
          </div>
          <!-- <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column gap-2">
            <b class="text-left font-normal text-base" style="color: #424242;">Status</b>
            <p-dropdown formControlName="status" [options]="statuses" optionLabel="name" optionValue="value" placeholder="Select Status"
              class="w-full" styleClass="selectFull" />
          </div> -->
          <div class="col-12 sm:col-6 md:col-4 xl:col-2 flex flex-column justify-content-end">
            <p-button label="Search" [loading]="isSearching" [disabled]="filterForm.invalid" class="w-full"
              styleClass="submitBtn" type="submit" />
          </div>
        </form>
      </div>
      <div class="w-full flex flex-column gap-2">
        <h2 class="w-full block text-left font-medium text-xl">Meetings</h2>
        <p-table *ngIf="meetings && meetings.length > 0; else noRecordsFound" [value]="meetings" [lazyLoadOnInit]="false"
          [paginator]="meetings.length!=total" [rows]="rowSize" [loading]="isSearching" [totalRecords]="total" [showCurrentPageReport]="true"
          [first]="first" [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [rowsPerPageOptions]="[10, 20, 30]"
          [showPageLinks]="true" styleClass="p-datatable-gridlines tableCon" [tableStyle]="{ 'min-width': '50rem' }">
          <ng-template pTemplate="header">
            <tr>
                <th>Mentor Name</th>
                <th>Student Name</th>
                <th>Date</th>
                <th>Meeting Time</th>
                <th>Actions</th>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-meeting>
            <tr style="background-color: #FFDEDE;">
                <td>   
                    <b class="text-left text-base font-medium" style="letter-spacing: -.5px;">{{meeting.mentorFirstName+' '+meeting.mentorLastName}}</b>
                </td>
                <td>
                    <b class="text-left text-base font-medium" style="letter-spacing: -.5px;">{{meeting.studentFirstName+' '+meeting.studentLastName}}</b>
                </td>
                <td>{{getLocalDate(meeting.meetingDateTime)}}</td>
                <td>{{getLocalTime(meeting.meetingDateTime)}}</td>
                <td>
                    <div *ngIf="meeting.status!=2" class="button-group">
                      <p-button label="Join" icon="pi pi-check" styleClass="join" 
                      (onClick)="openCalendlyURI(meeting.joiningUrl)" />
                      <p-button label="Cancel" icon="pi pi-times" styleClass="cancel"
                      (onClick)="openCalendlyURI(meeting.cancelUrl)" />
                      <p-button label="Reschedule" icon="pi pi-undo" styleClass="resch"
                      (onClick)="openCalendlyURI(meeting.rescheduledUrl)" />
                    </div>
                </td>
                </tr>
            </ng-template>
        </p-table>
        <ng-template #noRecordsFound>
          <div class="w-full flex flex-column align-items-center py-4 gap-5">
            <div class="w-full flex align-items-center justify-content-center">
              <img src="../../../assets/icons/nodatafound.svg" alt="" class="w-full max-w-16rem">
            </div>
            <b class="text-center font-normal text-2xl" style="color: #000086;">No Data Found !</b>
          </div>
        </ng-template>
      </div>
    </div>
  </div>